<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <div *ngIf="activeCashReport">
            <h3>{{'Current cash report'|translate}}: {{activeCashReport.number}}</h3>
            <h4>{{'Cash'|translate}}: {{activeCashReport.cash}}zł</h4>
        </div>
        <button *ngIf="!activeCashReport && !processing" mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="openCashReport(lastCashReport)"
                aria-label="Open cash report">
            {{'Open cash report'|translate}}
        </button>
        <button *ngIf="activeCashReport && !processing" mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="closeCashReport(activeCashReport)"
                aria-label="Open cash report">
            {{'Close cash report'|translate}}
        </button>

        <button *ngIf="activeCashReport && !processing" mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newCashReportItem(true)"
                aria-label="New Cash report">
            {{'New income'|translate}}
        </button>
        <br/>
        <button *ngIf="activeCashReport && !processing" mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newCashReportItem(false)"
                aria-label="New Cash report">
            {{'New outcome'|translate}}
        </button>

        <div *ngIf="processing">
            {{'Processing'|translate}}...
        </div>
    </div>

    <div class="nav material2">
<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple [routerLink]="'/cash-reports'" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">menu</mat-icon>-->
<!--                <span>{{'Cash reports'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
